import { Component, OnInit } from '@angular/core';
import { BaseDynamicFormComponent } from 'src/app/common/components/dynamic-form-v2/components/base-dynamic-form/base-dynamic-form.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicInputType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicInputType';
import { InputFieldType } from 'src/app/common/components/dynamic-form-v2/enums/InputFieldType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { BaseInputValidationServiceService } from 'src/app/common/services/base-input-validation-service.service';

@Component({
  selector: 'app-schedule-type-form-v2',
  templateUrl: './schedule-type-form-v2.component.html',
  styleUrls: ['./schedule-type-form-v2.component.sass']
})
export class ScheduleTypeFormV2Component extends BaseDynamicFormComponent implements OnInit
{
  scheduleTypeRecord: BaseEntityDto = new BaseEntityDto();
  constructor(private validation: BaseInputValidationServiceService)
  {
    super();
  }

  /**
   * Schedule Type Form V2 Initial Implementation
   */
  ngOnInit()
  {
    this.fields =
    [
      {
        title: "Schedule Type Data",
        fields:
        [
          {
            name: "Description",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'description',
            isRequired: true,
            label: 'Description',
          },
          {
            name: "Color",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.ColorPicker],
            clearField: true,
            key: 'color',
            isRequired: true,
            label: 'Color',
          }
      ],
      type: DynamicCardType.Card
      },
    ]
    // This will help us to define fields
    // with pre-established values.
    // This is just an example, there is no
    // need to add it if it's not necessary.
    this.scheduleTypeRecord =
    {
      enabled: false
    };
    this.title = "Schedule Type";
    this.viewRoute = 'schedule-types';
    this.isLoading = false;
  }

}
